import React from "react";
import { Box, Grid, Typography } from "@mui/material";

const InformationCards = () => {
  return (
    <Box
      sx={{
        backgroundColor: "white",
        px: 6,
        pt: 4,
        pb: { xs: 4, sm: 0 },
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: 6,
        borderRadius: "24px",
        width: "100%",
      }}
    >
      <Grid
        container
        spacing={{ xs: 6, lg: 20 }}
        sx={{
          width: { xs: "100%", lg: "90%" },
        }}
      >
        <Grid item xs={12} md={6}>
          <Box
            sx={{
              height: { xs: "210px", sm: "200px" },
              width: "100%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexDirection: "column",
              gap: 1,
              background:
                "radial-gradient(50% 50% at 50% 50%, #00B46C 0%, #019651 100%)",
              borderRadius: "24px",
              px: { xs: 2, sm: 6 },
              pb: 2,
              pt: { xs: 4, sm: 8 },
              textAlign: "center",
              position: "relative",
            }}
          >
            <Box
              component="img"
              src={"/media/image/_.svg"}
              alt="star"
              sx={{
                width: { xs: 20, sm: 30 },
                height: { xs: 20, sm: 30 },
                objectFit: "contain",
                position: "absolute",
                top: "8%",
              }}
            />

            <Typography
              sx={{
                fontSize: { xs: 14, sm: 18 },
                color: "#fff",
                fontWeight: 500,
              }}
            >
              صندوق سرمایه گذاری در اوراق با درآمد ثابت برلیان شهر
            </Typography>

            <Typography
              sx={{
                fontWeight: 800,
                fontSize: { xs: 16, sm: 20 },
                color: "#fff",
              }}
            >
              با نماد «بلد»
            </Typography>

            <Typography
              sx={{
                fontSize: { xs: 14, sm: 18 },
                color: "#fff",
                fontWeight: 500,
              }}
            >
              «صندوق درآمد ثابت بلد؛ راه بلد روز های نامطمئن»
            </Typography>
          </Box>
        </Grid>

        <Grid item xs={12} md={6}>
          <Box
            sx={{
              height: { xs: "210px", sm: "200px" },
              width: "100%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexDirection: "column",
              gap: 1,
              background:
                "radial-gradient(50% 50% at 50% 50%, #00B46C 0%, #019651 100%)",
              borderRadius: "24px",
              px: { xs: 2, sm: 6 },
              pb: 2,
              pt: { xs: 4, sm: 8 },
              textAlign: "center",
              position: "relative",
            }}
          >
            <Box
              component="img"
              src={"/media/image/_.svg"}
              alt="star"
              sx={{
                width: { xs: 20, sm: 30 },
                height: { xs: 20, sm: 30 },
                objectFit: "contain",
                position: "absolute",
                top: "8%",
              }}
            />

            <Typography
              sx={{
                fontSize: { xs: 14, sm: 18 },
                color: "#fff",
                fontWeight: 500,
              }}
            >
              صندوق سرمایه گذاری در سهام{" "}
              <Box
                component="span"
                sx={{
                  fontWeight: 800,
                  fontSize: { xs: 16, sm: 20 },
                }}
              >
                با نماد «برلیان»{" "}
              </Box>
              سرمایه گذاری هوشمند با تیمی که بازار را می شناسد
            </Typography>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default InformationCards;
